// Componente BodyRegister - Refatorado para usar estrutura modular
import React from "react";
import { ToastContainer } from "react-toastify";
import RegisterContent from "./components/RegisterContent";
import { useRegister } from "./hooks/useRegister";

/**
 * Componente BodyRegister - Corpo principal do Register
 * Utiliza hooks customizados e componentes modulares para manter
 * o código organizado e reutilizável
 */
function BodyRegister() {
  const {
    informationPlague,
    containPlague,
    plot,
    auxValidator,
    bracellPlantCount,
    setBracellPlantCount,
    parcelas,
    handleChangeInformationArea,
    handleChangeInformationPlague,
    handleChangeInformationDataBasic,
    handleChangeInfestation,
    handleClickSaveRegister,
    setDataForm
  } = useRegister();

  return (
    <>
      <RegisterContent
        informationPlague={informationPlague}
        containPlague={containPlague}
        plot={plot}
        auxValidator={auxValidator}
        bracellPlantCount={bracellPlantCount}
        onBracellPlantCountChange={setBracellPlantCount}
        parcelas={parcelas}
        onInformationArea={handleChangeInformationArea}
        onInformationPlague={handleChangeInformationPlague}
        onInformationDataBasic={handleChangeInformationDataBasic}
        onInfestation={handleChangeInfestation}
        onDataForm={setDataForm}
        onSaveRegister={handleClickSaveRegister}
      />
      <ToastContainer />
    </>
  );
}

export default BodyRegister;

